import { render, staticRenderFns } from "./TeacherStudents.vue?vue&type=template&id=4dd56df4&"
import script from "./TeacherStudents.vue?vue&type=script&lang=js&"
export * from "./TeacherStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports